import { DefaultTheme } from 'styled-components';
import { Z_INDEX_HEADER_BAR, Z_INDEX_MAP, Z_INDEX_MAP_CONTROL_BOX } from './constants';
import { getBreakpoints } from './breakpoints';

export type Theme = typeof THEME;

const SPACING_UNIT = 8;

const THEME_WITHOUT_BREAKPOINTS: Omit<DefaultTheme, 'breakpoints'> = {
  spacing: (multiple = 1) => SPACING_UNIT * multiple,
  colors: {
    mono: {
      ui01: '#171719',
      ui02: '#202123',
      ui03: '#262a2d',
      ui04: '#373d43',
      ui05: '#5a6872',
      ui06: '#c6cdd2',
      text01: '#fff',
      text02: '#c6cdd2',
      text03: '#98a5ae',
    },
    threshold: {
      low: '#a0f751',
      lowmid: '#d1d40e',
      mid: '#f9ef00',
      midhigh: '#ff7326',
      high: '#dc4545',
    },
    brand: {
      brand01: '#1b838b',
      brand02: '#6fb1b6',
      brand03: '#135b63',
    },
    trajectory: {
      primary: '#785ef0',
      secondary: '#ffffff',
    },
    feedback: {
      error: '#dc4545',
      success: '#a0f751',
      warning: '#d1d40e',
    },
  },
  font: {
    default: {
      family: 'Gilroy, Arial, Helvetica, sans-serif',
      weight: {
        light: 200,
        normal: 400,
        bold: 700,
      },
    },
    size: {
      xs: 1.1,
      sm: 1.2,
      md: 1.4,
      lg: 1.6,
      xl: 1.8,
      xxl: 2.0,
      xxxl: 2.8,
    },
  },
  blueprint: {
    namespace: 'bp6',
  },
  zIndex: {
    map: Z_INDEX_MAP,
    mapControlBox: Z_INDEX_MAP_CONTROL_BOX,
    headerBar: Z_INDEX_HEADER_BAR,
  },
};

export const THEME = {
  ...THEME_WITHOUT_BREAKPOINTS,
} as DefaultTheme;

THEME.breakpoints = function (this: Theme) {
  return getBreakpoints(this);
}.bind(THEME)();
